import { render, staticRenderFns } from "./_tableManageCompany.vue?vue&type=template&id=147ec720"
import script from "./_tableManageCompany.vue?vue&type=script&lang=js"
export * from "./_tableManageCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports